import { useEffect, useState } from "react";
import { Alert } from "@mui/material";
import ConfigService from "../../../services/config.service";

// #17 - Outside production we never transmit outbound API calls; we only record
// the request we would have sent. This banner makes that unmistakable on the API
// Logs page so nobody mistakes a recorded request for a real one.
const MockBanner = () => {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    ConfigService.fetchEnvironment()
      .then(setEnv)
      .catch(() => setEnv(null));
  }, []);

  if (!env || env.sendsExternalApiCalls) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <strong>Mocked environment ({env.environment}).</strong> API calls shown
      here are <strong>recorded only</strong>. Nothing is actually sent to
      Freshservice, Docusign, or any external system. Real calls are made only in
      production.
    </Alert>
  );
};

export default MockBanner;
